import React from 'react';
// import FitterLocator from '../../fitters-locator/containers/FittersLocator';
const Main = () => (
    <div className="main-content">
        <div className="row">

            <div className="col-md-12 home">
                <h1>Wright Balance: The New Science of Balance</h1>
                <h1>Find Balance for Your Sport or Activity for Improved Performance and Health</h1>
                <p>"Nature knows No Right or Wrong, Only Balance and Imbalance"</p>
            </div>
        </div>

        <div className="row videos">

            <div className="col-md-12">
                {/* <FitterLocator/> */}
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="video-big">
                            <iframe title="home page" src="//fliphtml5.com/azhq/tazi" allowFullScreen={true} allowTransparency={true} frameBorder={0} height="500px" width="100%">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
)

export default Main;


// WEBPACK FOOTER //
// ./src/main/containers/Main.js